import { Injectable } from '@angular/core';
import {ExgPacketDecoder} from '../core/interfaces/exg_interface';
import {BehaviorSubject} from 'rxjs';
import {ToastrMessageService} from "./toastr-message/toastr-message.service";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class MuscleDataService {

  muscleDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  dataStreamingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  bluetoothServiceSubject: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  deviceSubject: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  artefaktSubject: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
  tooHightArtefact: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  sensorConnectState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);
  currentImpedance = 0;

  userId = '';

  constructor(
    private toast: ToastrMessageService,
    private translate: TranslateService,
    private router: Router
  ) { }


  decodeMuscleData(value: any): void {
    const decoded = ExgPacketDecoder.decode(new Uint8Array(value));
    const lastCorrectData = ExgPacketDecoder.lastCorrectData;
    if (decoded) {
      // decoded.data.bp_ch1[9] = 2;
      // decoded.data.impedance = [100];
      this.muscleDataSubject.next(decoded);
    } else {
      if (ExgPacketDecoder.lastCorrectData) {
        // lastCorrectData.data.bp_ch1[9] = 2;
        // lastCorrectData.data.impedance = [100];
        this.muscleDataSubject.next(lastCorrectData);
      }
    }
    // ExgPacketDecoder.decode(new Uint8Array(value))
  }
  handleSensorConnectState() {
    this.sensorConnectState.subscribe((state) => {
      if (state === false) {
        if (this.router.url !== '/training-screen' && this.router.url !== '/test') {
          this.toast.message(`${this.translate.instant('TRAINING_SCREEN.SENSOR_DISCONNECT_GLOBAL')}`, '', 'toast-danger', 10000);
        }
      }
    });
  }
}
